<progress-spinner *ngIf="isLoading"></progress-spinner>
<div *ngIf="!isLoading">
  <div *ngIf="action === 'no-esams'">
    <div class="modal-header">
      <div class="title">
        <span class="header"> Transfer Selected JMEPs </span>
      </div>
      <div class="btn-group" (click)="closeDialog()">
        <i class="mdi mdi-close close-icon"></i>
      </div>
    </div>
    <mat-dialog-content fxLayout="row" class="no-data">
      <div>No ESAMs available to transfer devices</div>
    </mat-dialog-content>
    <div class="action-btn">
      <button
       mat-button mat-raised-button
       color="primary"
       (click)="closeDialog()">OK</button>
    </div>
  </div>

  <div class="transfer-popup" *ngIf="action === 'transfer'">
    <div class="popup-header">
      <span class="popup-title">Transfer Selected JMEPs {{ transferJmepName }}</span>
      <div class="btn-group" (click)="closeDialog()">
        <i class="mdi mdi-close close-icon"></i>
      </div>
    </div>

    <div class="popup-content" *ngIf="action === 'transfer' && !actionInProgress">
      <p class="transfer-message">{{ transferJmepsList.length }} device(s) selected for transfer</p>

      <div class="dropdown-section">
        <label for="esamDropdown" class="dropdown-label">
          Choose the ESAM where devices will be transferred
        </label>
        <mat-select class="option-list" [(ngModel)]="selectedEsamName" name="probe" id="esamDropdown">
          <mat-option *ngFor="let esam of transferEsamsList" [value]="esam">{{ esam }}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="popup-content" *ngIf="action === 'transfer' && actionInProgress">
      <div class="actions-container">
        <mat-spinner [diameter]="50"></mat-spinner>
        <div class="infotext">Transferring device(s). This may take some time... </div>
      </div>
    </div>
    <div class="popup-actions">
      <button
        *ngIf="!actionInProgress"
        mat-raised-button
        color="primary"
        (click)="transferJMEPs()"
        [disabled]="!selectedEsamName"
      >
        TRANSFER
      </button>
      <button
        *ngIf="!actionInProgress"
        mat-button mat-raised-button
        class="plain-btn"
        (click)="closeDialog()">CANCEL</button>
      <button
        *ngIf="actionInProgress"
        mat-button mat-raised-button
        class="plain-btn"
        (click)="closeDialog()">CLOSE</button>
    </div>
  </div>
</div>
